import React, { useState } from "react";
import Page, { Grid, GridColumn } from "@atlaskit/page";
import { useSelector, useDispatch } from "react-redux";
import StarIcon from "@atlaskit/icon/core/star-starred";
import FileIcon from "@atlaskit/icon/core/page";
import ActionSidebarSection from "./ActionSidebarSection";
import { useNavigate, useParams } from "react-router-dom";
import { LinkItem } from "@atlaskit/menu";
import ConfirmModal from "../../../../common/components/ConfirmModal";
import { setEditorSaved, selectFlow } from "../../../../redux/actions/integrationActions";
import { getFlow } from "../../../../common/utils/integration.util";
import TableIcon from "@atlaskit/icon/core/table";
import AngleBracketsIcon from "@atlaskit/icon/core/angle-brackets";
import CameraIcon from "@atlaskit/icon/core/camera";
import { clearLog, getExecutionLog } from "../../../../redux/actions/logActions";
import { toggleLoading } from "../../../../redux/actions/messageActions";
import CheckMarkIcon from "@atlaskit/icon/core/check-mark";

const FlowNavigationSidebar = () => {
  const [isOpen, setOpen] = useState(false);
  const [navPath, setNavPath] = useState("");
  const dispatch = useDispatch();
  const saved = useSelector((state) => state.integration.saved);
  const flow = useSelector((state) => state.integration.flow);
  const flows = useSelector((state) => state.integration.flows);
  const navigate = useNavigate();
  const { flowId, section = "details" } = useParams();

  const isLogPath = (path) => path.endsWith("/log");

  const loadFlowLogs = () => {
    if (!flowId) {
      return;
    }
    dispatch(clearLog());
    dispatch(getExecutionLog(flowId, null, null, null, null));
    dispatch(toggleLoading(true, "Loading..."));
  };

  const onConfirmModalNavigate = (id) => {
    if (isLogPath(navPath)) {
      loadFlowLogs();
    }
    dispatch(setEditorSaved(true));
    dispatch(selectFlow(getFlow(flow.id, flows)));
    navigate(navPath);
    setOpen(false);
  };
  const onCloseNavigateModal = () => {
    setOpen(false);
  };
  const onClickNavigate = (newPath) => {
    setNavPath(newPath);
    if (saved) {
      if (isLogPath(newPath)) {
        loadFlowLogs();
      }
      navigate(newPath);
    } else {
      setOpen(true);
    }
  };

  return (
    <div className="ihub-flex1">
      <ConfirmModal
        action="discard changes"
        targetName={flow.name}
        targetId={flow.id}
        isOpen={isOpen}
        onAction={onConfirmModalNavigate}
        onClose={onCloseNavigateModal}
      />
      <Page>
        <Grid spacing="comfortable">
          <GridColumn medium={12}>
            <LinkItem
              className={section === "details" ? "ihub-nav-selected" : ""}
              iconBefore={<FileIcon label="" />}
              onClick={() => onClickNavigate("/integration/" + flowId + "/details")}
            >
              Details
            </LinkItem>
          </GridColumn>
          <GridColumn medium={12}>
            <LinkItem
              className={section === "trigger" ? "ihub-nav-selected" : ""}
              iconBefore={<StarIcon label="" />}
              onClick={() => onClickNavigate("/integration/" + flowId + "/trigger")}
            >
              Trigger
            </LinkItem>
          </GridColumn>
          <GridColumn medium={12}>
            <LinkItem
              className={section === "log" ? "ihub-nav-selected" : ""}
              iconBefore={<TableIcon label="" />}
              onClick={() => onClickNavigate("/integration/" + flowId + "/log")}
            >
              Log
            </LinkItem>
          </GridColumn>
          <GridColumn medium={12}>
            <LinkItem
              className={section === "status" ? "ihub-nav-selected" : ""}
              iconBefore={<CheckMarkIcon label="" />}
              onClick={() => onClickNavigate("/integration/" + flowId + "/status")}
            >
              Run History
            </LinkItem>
          </GridColumn>
          <GridColumn medium={12}>
            <LinkItem
              className={section === "variables" ? "ihub-nav-selected" : ""}
              iconBefore={<AngleBracketsIcon label="" />}
              onClick={() => onClickNavigate("/integration/" + flowId + "/variables")}
            >
              Flow Variables
            </LinkItem>
          </GridColumn>
          <GridColumn medium={12}>
            <LinkItem
              className={section === "backups" ? "ihub-nav-selected" : ""}
              iconBefore={<CameraIcon label="" />}
              onClick={() => onClickNavigate("/integration/" + flowId + "/backups")}
            >
              Backups
            </LinkItem>
          </GridColumn>
          <GridColumn medium={12}>
            <ActionSidebarSection navigationCallback={onClickNavigate} />
          </GridColumn>
        </Grid>
      </Page>
    </div>
  );
};
export default FlowNavigationSidebar;
